import React, { useEffect, useState } from 'react';
import styles from './BotoneraDesplegable.module.css';

const BotoneraDesplegable = (props) => {
  const lista = props.lista;
  const renderBody = props.renderBody;
  const desplegarPrimero = props.desplegarPrimero;
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    if (desplegarPrimero) {
      setOpenIndex(0);
    }
  }, [desplegarPrimero]);

  const handleToggle = (index) => {
    setOpenIndex((previous) => (previous === index ? null : index));
  };

  return (
    <div className={styles.container}>
      {lista.map((item, index) => (
        <div key={item.id} className={styles.item}>
          <button className={styles.button} onClick={() => handleToggle(index)}>
            {item.descripcion ? item.descripcion : item.nombre}
          </button>
          {openIndex === index && <div className={styles.dropdown}>{renderBody(item)}</div>}
        </div>
      ))}
    </div>
  );
};

export default BotoneraDesplegable;
